import * as _ from 'underscore'

import { ColumnModel } from '../../modules/api/api.models'
import { Enums } from '../../models/common'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'
import { SYSTEM_SERVICE_NAME, SystemService } from '../system'
import { PACKAGE_SERVICE_NAME, PackageService } from '../package'

//#region Public Types

export const ORDER_RELATED_PACKAGES_SERVICE_NAME = 'OrderRelatedPackagesService'
export const ORDER_RELATED_PACKAGES_SERVICE_PROVIDER_NAME = 'OrderRelatedPackagesServiceProvider'

//#endregion


export class OrderRelatedPackagesService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Order.RelatedPackages]' }


    //#endregion


    //#region Ctor

    constructor(private packageService: PackageService, private systemService: SystemService) { }

    //#endregion


    //#region Columns

    public getRelatedPackagesColumns(): JQueryPromise<ColumnModel[]> {
        return this.packageService.getMainGridColumns()
    }

    //#endregion


    //#region Details

    public openRelatedPackageDetails(idPackage: number): void {
        this.systemService.openDetails({
            moduleName: Enums.SimaxModuleName.Package,
            referenceObjectId: idPackage
        })
    }

    //#endregion
}


export class OrderRelatedPackagesServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [PACKAGE_SERVICE_NAME, SYSTEM_SERVICE_NAME, function (packageService: PackageService, systemService: SystemService) {
        return new OrderRelatedPackagesService(packageService, systemService);
    }]

    //#endregion
} 